"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndent = exports.OpPerform = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const getEnabledQuestionsAndSections_1 = __importDefault(require("@opsbase/lib-form/helpers/getEnabledQuestionsAndSections"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const OpPerformHeader_1 = __importDefault(require("../OpPerformHeader"));
const OpPerformQuestion_1 = __importDefault(require("../OpPerformQuestion"));
const makeMyClasses = () => ({
    root: {},
    outer: {
        overflow: 'hidden',
        background: lib_palette_1.default.WhiteSmoke.main,
        borderTop: `1px solid ${lib_palette_1.default.LavendarGrey.main}`,
    },
    inner: {
        padding: 16,
    },
    current: {
        minWidth: 400,
        maxWidth: 400,
        height: '100%',
        padding: 16,
        background: lib_palette_1.default.White.main,
        borderLeft: `1px solid ${lib_palette_1.default.LavendarGrey.main}`,
    },
});
function OpPerform(props) {
    const { highlightSelected = false } = props;
    const { form } = (0, usePerform_1.default)();
    const activeQuestionsAndSections = (0, getEnabledQuestionsAndSections_1.default)(form.questionTree);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.root } },
        props.header || react_1.default.createElement(OpPerformHeader_1.default, null),
        react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.outer } },
            react_1.default.createElement(Vertical_1.default, { scrollY: true, gutter: true, classes: { root: myCss.inner } }, activeQuestionsAndSections.map((questionNode, idx) => (react_1.default.createElement(OpPerformQuestion_1.default, { key: `question${idx}`, questionNode: questionNode, highlightSelected: highlightSelected }))))))), [activeQuestionsAndSections, highlightSelected, myCss, props.header]);
}
exports.OpPerform = OpPerform;
exports.default = OpPerform;
function getIndent(form, q) {
    var _a;
    const parentQ = form.questions[q === null || q === void 0 ? void 0 : q.parentNodeId];
    if (!(q === null || q === void 0 ? void 0 : q.parentNodeId) ||
        (q === null || q === void 0 ? void 0 : q.parentNodeId) === 'root' ||
        (parentQ === null || parentQ === void 0 ? void 0 : parentQ.type) === FormQuestionType_1.default.REPETITION ||
        (parentQ === null || parentQ === void 0 ? void 0 : parentQ.type) === FormQuestionType_1.default.QUESTIONSET ||
        (parentQ === null || parentQ === void 0 ? void 0 : parentQ.type) === FormQuestionType_1.default.SECTION)
        return [];
    const enabledQuestions = (_a = parentQ === null || parentQ === void 0 ? void 0 : parentQ.subQuestions.filter(z => z.enabled)) !== null && _a !== void 0 ? _a : [];
    const qIdx = enabledQuestions.findIndex(qq => qq.nodeId === q.nodeId);
    if (qIdx < enabledQuestions.length - 1) {
        return [...getIndent(form, parentQ), false];
    }
    else {
        return [...getIndent(form, parentQ), true];
    }
}
exports.getIndent = getIndent;
